<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <h3 class="card-title mb-3">会員検索</h3>
            <p>
              会員検索後に表示される会員一覧から、会員に関する操作を行ってください。
            </p>
            <CForm class="search-filter">
              <CRow class="mb-2">
                <CCol sm="7" lg="5">
                  <!-- <CInput
                    label="カードID"
                    class="search-input"
                    placeholder="カードIDを入力（部分一致）"
                    description="カードIDには5桁以上の値を入力してください"
                    horizontal
                    v-model="query.cardId"
                    @keydown.enter="onSearchQuery($event, 'cardId')"
                    type="tel"
                  /> -->

                  <div class="form-group form-row m-0">
                    <label class="col-form-label col-sm-3">カードID</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="カードIDを入力（部分一致）"
                        v-model="ConvertId"
                        @keydown.enter="onSearchQuery($event, 'cardId')"
                      />
                      <small class="form-text text-muted w-100"
                        >カードIDには5桁以上の値を入力してください</small
                      >
                    </div>
                  </div>
                </CCol>

                <CCol sm="3" lg="2">
                  <CButton
                    @click="getSearchQuery('cardId')"
                    class="info-button w-100"
                    :disabled="$v.query.cardId.$invalid"
                  >
                    <i class="icon cil-search"></i> 検索
                  </CButton>
                  <!-- 検索 -->
                </CCol>
              </CRow>
              <CRow class="mb-2">
                <CCol sm="7" lg="5">
                  <CInput
                    label="ユーザ名"
                    class="search-input"
                    placeholder="ユーザ名を入力して検索してください（完全一致）"
                    horizontal
                    v-model="query.username"
                    @keydown.enter="onSearchQuery($event, 'username')"
                    type="tel"
                  />
                </CCol>
                <CCol sm="3" lg="2">
                  <CButton
                    @click="getSearchQuery('username')"
                    class="info-button w-100"
                    :disabled="!query.username"
                  >
                    <i class="icon cil-search"></i> 検索
                  </CButton>
                  <!-- 検索 -->
                </CCol>
              </CRow>
              <CRow class="mb-2">
                <CCol sm="7" lg="5">
                  <CInput
                    label="氏名"
                    class="search-input"
                    placeholder="氏名または氏名(カナ)を入力して検索してください（部分一致）"
                    horizontal
                    v-model="query.name"
                    @keydown.enter="onSearchQuery($event, 'name')"
                  />
                </CCol>
                <CCol sm="3" lg="2">
                  <CButton
                    @click="getSearchQuery('name')"
                    class="info-button w-100"
                    :disabled="!query.name"
                  >
                    <i class="icon cil-search"></i> 検索
                  </CButton>
                </CCol>
              </CRow>
              <CRow class="mb-2">
                <CCol sm="7" lg="5">
                  <CInput
                    label="Eメールアドレス"
                    class="search-input"
                    placeholder="Eメールアドレスを入力して検索してください（部分一致）"
                    horizontal
                    v-model="query.email"
                    @keydown.enter="onSearchQuery($event, 'email')"
                    type="email"
                  />
                </CCol>
                <CCol sm="3" lg="2">
                  <CButton
                    @click="getSearchQuery('email')"
                    class="info-button w-100"
                    :disabled="!query.email"
                  >
                    <i class="icon cil-search"></i> 検索
                  </CButton>
                </CCol>
              </CRow>
              <CRow class="mb-2">
                <CCol sm="7" lg="5">
                  <CInput
                    label="電話番号"
                    class="search-input"
                    placeholder="電話番号を入力して検索してください（部分一致）"
                    horizontal
                    v-model="query.phone"
                    @keydown.enter="onSearchQuery($event, 'phone')"
                    type="tel"
                  />
                </CCol>
                <CCol sm="3" lg="2">
                  <CButton
                    @click="getSearchQuery('phone')"
                    class="info-button w-100"
                    :disabled="!query.phone"
                  >
                    <i class="icon cil-search"></i> 検索
                  </CButton>
                </CCol>
              </CRow>
              <CRow class="mb-2">
                <CCol sm="7" lg="5">
                  <CInput
                    label="郵便番号"
                    class="search-input"
                    placeholder="郵便番号を入力して検索してください（前方一致）"
                    horizontal
                    v-model="query.zipcode"
                    @keydown.enter="onSearchQuery($event, 'zipcode')"
                    type="tel"
                  />
                </CCol>
                <CCol sm="3" lg="2">
                  <CButton
                    @click="getSearchQuery('zipcode')"
                    class="info-button w-100"
                    :disabled="!query.zipcode"
                  >
                    <i class="icon cil-search"></i> 検索
                  </CButton>
                </CCol>
              </CRow>
              <CRow class="mb-2">
                <CCol sm="7" lg="5">
                  <CInput
                    label="住所"
                    class="search-input"
                    placeholder="住所を入力して検索してください（部分一致）"
                    description="データ量が多いため検索に時間がかかる可能性があります。"
                    horizontal
                    v-model="query.address"
                    @keydown.enter="onSearchQuery($event, 'address')"
                    type="tel"
                  />
                </CCol>
                <CCol sm="3" lg="2">
                  <CButton
                    @click="getSearchQuery('address')"
                    class="info-button w-100"
                    :disabled="!query.address"
                  >
                    <i class="icon cil-search"></i> 検索
                  </CButton>
                </CCol>
              </CRow>
              <transition name="fade">
                <CRow v-if="notFound">
                  <CCol lg="6">
                    <CAlert color="danger">会員が見つかりませんでした。</CAlert>
                  </CCol>
                </CRow>
              </transition>
            </CForm>
          </CCardHeader>

          <CCollapse :show="collapse" :duration="200">
            <!-- <CCollapse :show="true" :duration="200"> -->
            <CCardBody>
              <div class="user-info-table">
                <dl class="row">
                  <dt class="col-sm-12">
                    <h4 class="sub-title">会員一覧</h4>
                    全登録数: {{totalUserCount}} | 検索ヒット件数: {{userCount}}
                  </dt>
                </dl>
                <CDataTable
                  class="mb-0 table-outline"
                  hover
                  size="sm"
                  :items="users"
                  :fields="tableFields"
                  head-color="light"
                  table-filter
                  column-filter
                  sorter
                  itemps-per-page-select
                  :items-per-page="100"
                  pagination
                  v-if="!loading"
                >
                  <!-- sorter
                :sorterValue.sync="tableSorter" -->

                  <td slot="cardId" class="text-left" slot-scope="{ item }">
                    <strong>{{ item.cardId }}</strong>
                  </td>
                  <td slot="familyName" slot-scope="{ item }">
                    <strong>{{ item.familyName }}</strong>
                  </td>
                  <td slot="givenName" slot-scope="{ item }">
                    <strong>{{ item.givenName }}</strong>
                  </td>
                  <td slot="lastName" slot-scope="{ item }">
                    <strong>{{ item.lastName }}</strong>
                  </td>
                  <td slot="firstName" slot-scope="{ item }">
                    <strong>{{ item.firstName }}</strong>
                  </td>
                  <td slot="email" slot-scope="{ item }">
                    <strong>{{ item.email }}</strong>
                  </td>
                  <td slot="mobile" slot-scope="{ item }">
                    <strong>{{ item.mobile }}</strong>
                  </td>
                  <template #profile_edit="{ item }">
                    <td class="py-2 text-center">
                      <CButton
                        color="info"
                        square
                        block
                        size="sm"
                        @click="onMemberPage(item.name)"
                        >編集</CButton
                      >
                    </td>
                  </template>
                  <template #user_dashboard="{ item }">
                    <td class="py-2 text-center">
                      <CButton
                        color="info"
                        square
                        block
                        size="sm"
                        @click="onUserDashboardPage(item.name)"
                        >表示</CButton
                      >
                    </td>
                  </template>
                  <template #id_update="{ item }">
                    <td class="py-2 text-center">
                      <CButton
                        color="info"
                        square
                        block
                        size="sm"
                        @click="onUserIdUpdate(item.name)"
                        >会員証発行</CButton
                      >
                    </td>
                  </template>
                  <template #memberDiscountList="{ item }">
                    <td class="py-2 text-center">
                      <CButton
                        color="info"
                        square
                        block
                        size="sm"
                        @click="onMemberDiscountListClicked(item.id)"
                        >割引一覧</CButton
                      >
                    </td>
                  </template>
                </CDataTable>
              </div>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CCol>
    </CRow>
     
    <!-- <CModal
      color="danger"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="errorModal"
    >
      Error: {{ errors }}
      <template #header> セッションのタイムアウト </template>
      <template #footer>
        <CButton @click="goLogoutPage()" color="success"
          ><i class="icon cil-signin"></i> ログインへ</CButton
        >
      </template>
    </CModal> -->
  </div>
</template>

<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  components: {},
  data() {
    return {
      canSearch: false,
      // searchResult: "",
      notFound: false,
      collapse: false,
      loading: false,
      errorModal: false,
      loadingsvg: require("../assets/loading.svg"),
      collapseDuration: 0,
      tableItems: [],
      PassError: 0,
      errors: "",

      query: {
        cardId: "",
        username: "",
        name: "",
        email: "",
        phone: "",
        zipcode: "",
        address: "",
      },

      users: [
        {
          familyName: "",
          givenName: "",
          firstName: "",
          lastName: "",
          gender: "",
          birth: "",
          email: "",
          mobile: "",
          cardId: "",
        },
      ],
      tableFields: [
        { key: "cardId", label: "カードID", _classes: "text-center bg-light" },
        { key: "familyName", label: "氏", _classes: "text-center bg-light" },
        { key: "givenName", label: "名", _classes: "text-center bg-light" },
        { key: "firstName", label: "氏(カナ)", _classes: "text-center bg-light" }, // TODO: 本来逆
        { key: "lastName", label: "名(カナ)", _classes: "text-center bg-light" }, // TODO: 本来逆
        { key: "email", label: "Eメールアドレス", _classes: "text-center bg-light" },
        { key: "mobile", label: "	電話番号", _classes: "text-center bg-light" },
        // { key: "電話番号", label: "提出時間", _classes: "text-right" },
        {
          key: "profile_edit",
          label: "会員情報",
          // _style: "width:6%",
          sorter: false,
          filter: false,
          _classes: "text-center bg-light",
        },
        {
          key: "user_dashboard",
          label: "ダッシュボード",
          // _style: "width:6%",
          sorter: false,
          filter: false,
          _classes: "text-center bg-light",
        },
        {
          key: "id_update",
          label: "会員証発行",
          // _style: "width:6%",
          sorter: false,
          filter: false,
          _classes: "text-center bg-light",
        },
       {
          key: "memberDiscountList",
          label: "割引一覧",
          sorter: false,
          filter: false,
          _classes: "text-center bg-light",
        },
      ],
      totalUserCount: 0,
    };
  },
  validations: {
    query: { cardId: { required, minLength: minLength(5) } },
  },
  methods: {

    //#region Event

    /** 割引一覧押下 */
    onMemberDiscountListClicked(uuid) {
      // 「会員割引一覧」に遷移
      this.$router.push({ path: `/member-discount-list/${uuid}` });
    },

    onSearchQuery(event, value) {
      if(!this.validateQuery(event, value)) return;
      this.getSearchQuery(value);
    },

    // go to member edit page with params
    onMemberPage(userName) {
      this.$router.push({ name: "会員情報編集", params: { userId: userName } });
    },
    // go to member point page
    onPointPage(userName) {
      this.$router.push({ name: "ポイント更新", params: { userId: userName } });
    },
    onUserIdUpdate(userName) {
      this.$router.push({ name: "会員証発行", params: { userId: userName } });
    },
    // go to user dashboard page
    onUserDashboardPage(userName) {
      this.$router.push({
        name: "会員ダッシュボード",
        params: { userId: userName },
      });
    },

    //#endregion Event


    //#region Request

    // search query
    getSearchQuery: function (value) {
      var urlRequest = `/rest/users`;
      switch (value) {
        case "cardId":
          urlRequest = `${urlRequest}?card=${this.query[value]}`;
          break;
        case "username":
          urlRequest = `${urlRequest}/${this.query[value]}`;
          break;
        default:
          // Note: case ["name", "email", "phone", "zipcode", "address"]
          urlRequest = `${urlRequest}?${value}=${this.query[value]}`;
          break;
      }

      this.loading = true;

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          if (value == "username") {
            // 会員リスト表示のため、JSONデータをthis.usersにpush
            this.users = [];
            this.users.push(resp.data);
          } else {
            this.users = resp.data;
          }

          // this.users = resp.data;
          console.log("User Data:" + JSON.stringify(this.users));
          // this.searchResult = "";
          this.loading = false;
          this.collapse = true;

          this.users == ""
            ? ((this.collapse = false), (this.notFound = true))
            : ((this.collapse = true), (this.notFound = false));
        })
        .catch((err) => {
          console.log(err);
          this.notFound = true;
           
          // alert(this.PassError)
          // if (err.response.status == 404) {
          //   this.errorModal = true;
          //   this.errors = "ログインのセッションが切れましたので、再度ログインしてください";
          // }
          // this.searchResult = "会員が見つかりませんでした。";
          this.loading = false;
          this.collapse = false;
        });
    },

    getTotalUserCount: function () {
      var urlRequest = "/rest/users/";
      this.loading = true;
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.totalUserCount = resp.data;
          console.log("User Data:" + JSON.stringify(this.totalUserCount));
          // this.searchResult = "";
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.notFound = true;
          this.loading = false;
        });
    },

    //#endregion Request


    //#region Method

    validateQuery(event, value){
      // 日本語入力中のEnterキー操作は無効
      if (event.keyCode === 229) return false;

      if(!value) return false;
      if(!this.query[value]) return false;

      return true;
    },

    getUserName(data) {
      return data.familyName + " " + data.givenName;
    },

    getUserNameKana(data) {
      return data.lastName + " " + data.firstName;
    },

    //#endregion Method

  },

  beforeMount() {
    this.getTotalUserCount();
  },

  computed: {

    ConvertId: {
      get() {
        return this.query.cardId;
      },
      set(value) {
        var conv = value.replace(/[\uff01-\uff5e]/g, function (ch) {
          return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
        });
        this.query.cardId = conv;
      },
    },

    userCount: {
      get() {
        return this.users.length;
      }
    }

  },
};
</script>

